import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NUM } from '@core/enum/num.enum';
import { SidebarService } from '@core/services/presenters/sidebar.service';
import { IconType } from '@core/type/icon.type';
import { IconWrapperComponent } from '@shared/design/molecules/icon-wrapper/icon-wrapper.component';

@Component({
  selector: 'app-layout-sidebar-item',
  imports: [CommonModule, RouterLink, RouterLinkActive, IconWrapperComponent],
  templateUrl: './layout-sidebar-item.component.html',
  styleUrl: './layout-sidebar-item.component.scss',
})
export class LayoutSidebarItemComponent {
  isExpanded: boolean = false;
  isAnimated: boolean = false;

  constructor(readonly sidebarService: SidebarService) {}

  ngOnInit() {
    this.sidebarService.$isAnimating.subscribe((value) => {
      this.$isAnimating = value;
    });

    this.sidebarService.$collapsed.subscribe((collapsed) => {
      if (collapsed && this.isExpanded) {
        this.isExpanded = false;
      }
    });
  }

  protected $link?: string;
  protected $icon?: IconType;
  protected $label?: string;
  protected $hasContent?: boolean;
  protected $isAnimating?: boolean;

  /** @default undefined */
  public get link(): string | undefined {
    return this.$link;
  }
  @Input() public set link(value: string | undefined) {
    this.$link = value;
  }

  /** @default undefined */
  public get icon(): IconType | undefined {
    return this.$icon;
  }

  @Input() public set icon(value: IconType | undefined) {
    this.$icon = value;
  }

  /** @default undefined */
  public get label(): string | undefined {
    return this.$label;
  }
  @Input() public set label(value: string | undefined) {
    this.$label = value;
  }

  /** @default undefined */
  public get hasContent(): boolean | undefined {
    return this.$hasContent;
  }
  @Input() public set hasContent(value: boolean | undefined) {
    this.$hasContent = value;
  }

  getFirstLetter(label: string | undefined) {
    if (!label) return '';
    return label.charAt(NUM.ZERO);
  }

  toggleExpand(): void {
    if (this.sidebarService.$collapsed.getValue()) {
      this.sidebarService.setCollapsed(false);
      setTimeout(() => {
        this.isExpanded = true;
      }, 250);
    } else {
      this.isExpanded = !this.isExpanded;
    }
  }

  get isAnimating() {
    return this.sidebarService.$isAnimating.getValue();
  }
}
